import type { RootState } from '@/lib/store';
import { muscleAdapter } from '@/entities/muscle/model/muscle.slice';

const baseSelectors = muscleAdapter.getSelectors((state: RootState) => state.muscles);
const muscleSliceSelectors = {
	...baseSelectors,
};

export { muscleSliceSelectors };
